import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { forwardRef, useState } from 'react';
import { compact } from 'lodash-es';
import { Checkmark } from '../../icons';
import { BottomSheetContentLayout } from '../BottomSheet';
import { useSheetStack } from '../OverlayContext/useSheetStack';
import { MobileSummaryCard } from '../TextField';
import { MobileTextFieldTID } from '../TextField/BaseTextField/BaseTextField.utils';
import { Typography } from '../Typography';
import styles from './MobileSelect.module.scss';
export function SelectOptionsBottomSheet(props) {
    var _ref;
    var _props_mobile;
    const { children, isSelected, saveOnSelect, testId } = props;
    const { popBottomSheetPage } = useSheetStack();
    const [tempValue, setTempValue] = useState(props.value);
    function handleSave(returnValue) {
        const valueToSave = returnValue != null ? returnValue : tempValue;
        if (valueToSave !== props.value && props.onChange) {
            props.onChange({
                target: {
                    value: valueToSave
                }
            });
        }
        popBottomSheetPage();
    }
    const clonedChildren = React.Children.map(children, (child)=>{
        if (/*#__PURE__*/ React.isValidElement(child)) {
            const childProps = child.props;
            const childTestId = childProps.testId;
            const selected = isSelected ? isSelected(childProps.value, tempValue) : childProps.value === tempValue;
            return /*#__PURE__*/ React.cloneElement(child, _object_spread_props(_object_spread({}, childProps), {
                selected,
                children: /*#__PURE__*/ _jsxs("div", {
                    className: styles.item,
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            children: childProps.children
                        }),
                        selected && /*#__PURE__*/ _jsx("div", {
                            className: styles.noShrink,
                            "data-testid": MobileTextFieldTID.SelectedItem(childTestId || testId),
                            children: /*#__PURE__*/ _jsx(Checkmark, {})
                        })
                    ]
                }),
                onClick: ()=>saveOnSelect ? handleSave(childProps.value) : setTempValue(childProps.value)
            }));
        }
        return null;
    });
    return /*#__PURE__*/ _jsx(BottomSheetContentLayout, {
        header: props.label ? {
            title: props.label,
            paddingBottom: 16
        } : undefined,
        footer: !saveOnSelect ? {
            primaryAction: {
                text: (_ref = (_props_mobile = props.mobile) === null || _props_mobile === void 0 ? void 0 : _props_mobile.saveButtonLabel) !== null && _ref !== void 0 ? _ref : 'Save',
                onClick: ()=>handleSave(),
                bi: {
                    name: 'save'
                }
            },
            paddingTop: 8
        } : undefined,
        children: clonedChildren
    });
}
function deriveDisplayValue(props) {
    var _props_mobile;
    if ((_props_mobile = props.mobile) === null || _props_mobile === void 0 ? void 0 : _props_mobile.displayValue) return props.mobile.displayValue;
    if (props.displayValue) return props.displayValue;
    const match = React.Children.toArray(props.children).find((child)=>{
        return /*#__PURE__*/ React.isValidElement(child) && child.props.value === props.value;
    });
    if (/*#__PURE__*/ React.isValidElement(match)) {
        return match.props.children;
    }
    return props.value;
}
export const MobileSelect = /*#__PURE__*/ forwardRef(function MobileSelect(props, _ref) {
    const { testId, disabled, error, helperText } = props;
    const { pushBottomSheetPage } = useSheetStack();
    return /*#__PURE__*/ _jsx(MobileSummaryCard, {
        testId: testId,
        items: [
            {
                title: props.label,
                titleTestId: MobileTextFieldTID.Label(testId),
                body: /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        /*#__PURE__*/ _jsx(Typography, {
                            ellipsis: true,
                            testId: MobileTextFieldTID.Value(testId),
                            skin: error ? 'error' : 'standard',
                            children: deriveDisplayValue(props)
                        }),
                        helperText && /*#__PURE__*/ _jsx(Typography, {
                            testId: MobileTextFieldTID.HelperText(testId),
                            skin: error ? 'error' : 'secondary',
                            children: helperText
                        })
                    ]
                }),
                actions: compact([
                    !disabled && {
                        type: 'edit',
                        testId: MobileTextFieldTID.EditButton(testId),
                        onClick: ()=>{
                            pushBottomSheetPage({
                                content: /*#__PURE__*/ _jsx(SelectOptionsBottomSheet, _object_spread({}, props))
                            });
                        },
                        // WHY: inherent action opening the options bottom-sheet; consumers cannot rename it (rule 6a) and it dispatches no onChange, so it cannot double-fire.
                        bi: {
                            name: 'edit'
                        }
                    }
                ])
            }
        ]
    });
});
